import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import {
  getUsers,
  GetUsersParams,
  updateUserStatus,
  UserStatus,
  changePassword,
  ChangePasswordPayload,
  updateAdminProfile,
  UpdateAdminPayload,
} from '@/api/users';

export function useUsers(params?: GetUsersParams) {
  return useQuery({
    queryKey: ['users-list', params],
    queryFn: () => getUsers(params),
    placeholderData: (previousData) => previousData,
  });
}

export function useUpdateUserStatus() {
  const queryClient = useQueryClient();

  return useMutation<void, AxiosError<{ message?: string }>, { userId: number; status: UserStatus }>({
    mutationFn: ({ userId, status }) => updateUserStatus(userId, status),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users-list'] });
    },
  });
}

export function useChangePassword() {
  return useMutation<void, AxiosError<{ message?: string }>, ChangePasswordPayload>({
    mutationFn: changePassword,
  });
}

export function useUpdateAdminProfile() {
  return useMutation<void, AxiosError<{ message?: string }>, UpdateAdminPayload>({
    mutationFn: updateAdminProfile,
  });
}
